export default [
  // layout
  {
    path: '/ebook',
    component: () => import('../../views/eBook/layout/index.vue'),
    name: 'ebook',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // list
  {
    path: '/list',
    component: () => import('../../views/eBook/list/index.vue'),
    name: 'list',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // pdf
  {
    path: '/pdf/:id',
    component: () => import('../../views/eBook/pdf/index.vue'),
    name: 'pdf',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
];
